<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content" v-if="client">
        <p class="title has-text-centered mgb-20px">
          {{ $t('ajoutDevis.informations.addClient')}}
        </p>
        <error-msg-component :messages="messagesErreur"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'ajoutDevis.problemOccurred'"
                             @close="error = $event"/>
        <div class="columns">
          <div class="column is-6">
            <b-field :label="$t('ajoutDevis.informations.commercialName')"
              :type="typeNomCommercial"
              class="obligatoire">
              <b-input v-model="client.nomCommercial"></b-input>
            </b-field>
            <b-field :label="$t('ajoutDevis.informations.compteComptable')">
              <b-input v-model="client.compteComptable"></b-input>
            </b-field>
            <b-field :label="$t('ajoutDevis.table.editionIntervenant.siret')">
              <b-input v-model="client.siret"></b-input>
            </b-field>
            <b-field :label="$t('ajoutDevis.table.editionIntervenant.tvaIntracommunautaire')">
              <b-input v-model="client.tvaIntracommunautaire"></b-input>
            </b-field>
            <b-checkbox v-model="client.prospect" v-if="estDevis"
               class="mgt-1_5em has-text-default column is-6">
              {{ $t('ajoutDevis.table.editionIntervenant.prospect') }}
            </b-checkbox>
          </div>
          <div class="column is-6">
            <b-field :label="$t('ajoutDevis.informations.postalAddress')"
              :class="{'obligatoire': !estDevis}">
              <app-adresse :showLibelle="false" :adresse="client.adressePostale"
                :tableName="TIERS"/>
            </b-field>
          </div>
        </div>
        <a class="lien" @click='AjoutClientComplet'>
          {{$t('ajoutDevis.clients.addFullCustomer')}}
        </a>
        <b-field class="mgt-10px">
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('ajoutDevis.actions.revert')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="creerClient()">
              {{ $t('ajoutDevis.actions.add')}}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import * as devisConf from '@/configuration/devisConf';
import * as typesCommande from '@/store/modules/commande-mutation-type';
import Adresse from '@/components/general/adresse';
import gestionType from '@/services/general/gestionType';
import clientGenerer from '@/services/tiers/genererTiers';
import creerIntervenant from '@/services/devisCommandes/creerIntervenant';
import { insertTiers } from '@/services/tiers/saveTiers';
import validation from '@/services/tiers/validationTiers';
import messageSucces from '@/services/general/messageSucces';
import addIntervenant from '@/services/devisCommandes/addIntervenant';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import { TIERS } from '@/configuration/ville/villeConf';
import { PLAN_MEDIA } from '@/configuration/bodac/planMedia/planMediaConfig';
import validationGeneral from '@/services/validation/validation';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Clients = createNamespacedHelpers('clients');
const Commandes = createNamespacedHelpers('commande');
const societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    nouveauDevisCommande: {
      type: Object,
      required: true,
    },
    nomClient: {
      type: String,
      required: true,
    },
    placeIntervenant: {
      type: Number,
      required: false,
      default: 0,
    },
    typeAjoutClientComplet: {
      type: String,
      default: '',
    },
  },
  components: {
    appAdresse: Adresse,
    errorMsgComponent,
  },
  data() {
    return {
      TIERS: TIERS,
      error: false,
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
      client: clientGenerer(),
    };
  },
  computed: {
    ...Clients.mapGetters({
      clients: 'clients',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    typeNomCommercial() {
      return gestionType(this.client.nomCommercial, this.error);
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    estDevis() {
      return this.nouveauDevisCommande.type === devisConf.TYPE_DEVIS;
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Clients.mapActions({
      setPlaceIntervant: 'setPlaceIntervant',
      setClientCourant: 'setClientCourant',
      addClient: 'addClient',
    }),
    ...Commandes.mapMutations({
      setCommandeCourant: typesCommande.SET_COMMANDE,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async creerClient() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesErreur = [];
        this.error = false;
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.client.societeId = this.societeActiveId;
        this.client = await insertTiers(this.client);
        if (this.nouveauDevisCommande.type === devisConf.TYPE_FACTURE) {
          this.$emit('intervenant', this.client);
        } else {
          addIntervenant(this.nouveauDevisCommande, creerIntervenant(this.client));
          this.client = clientGenerer();
        }
        this.error = false;
        this.$parent.close();
        messageSucces(this.$i18n.t('ajoutDevis.messages.successCustomerCreation'));
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, champsTiersTranslator);
          validation(e.response, this.messagesErreur);
          this.error = true;
          loadingComponent.close();
        }
      }
    },
    AjoutClientComplet() {
      this.setClientCourant(this.client);
      this.setCommandeCourant(this.nouveauDevisCommande);
      const type = this.nouveauDevisCommande.type || this.typeAjoutClientComplet;
      let routeData = {};
      switch (type) {
        case devisConf.TYPE_COMMANDE:
          this.$router.push({ name: 'm.bodac.clients/contacts-editCommande' });
          break;
        case devisConf.TYPE_DEVIS:
          this.$router.push({ name: 'm.bodac.clients/contacts-editDevis' });
          break;
        case PLAN_MEDIA:
          routeData = { name: 'm.bodac.clients/contacts-editPlanMedia' };
          if (this.$route.params.id) routeData.params = { planMediaId: this.$route.params.id };
          this.$router.push(routeData);
          break;
        default:
          this.setPlaceIntervant(this.placeIntervenant);
          this.$router.push({ name: 'm.bodac.clients/contacts-editFacture' });
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
      this.client.nomCommercial = this.nomClient;
      this.client.type = TIERS_TYPE_CLIENT;
      this.client.sousTypes = [TIERS_SOUS_TYPE_AUCUN];
      this.client.modeReglementId = this.societeActive.modeReglementId;
      this.client.delaiReglementId = this.societeActive.delaiReglementId;
      this.client.factureParMail = this.societeActive.factureParMail;
      if (this.moduleStockTiersActive) {
        this.client.lieuStockage = this.societeActive.lieuStockageDefault;
      }
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>

<style>
</style>
